import React, { useContext, useEffect } from 'react';
import { Typography, Card } from '@arco-design/web-react';
import locale from './locale';
import useLocale from '@/utils/useLocale';
import { standalonePagesStyles as styles } from '@/style';
import { GlobalContext } from '@/context';
import Logo from '@/assets/logo.svg';
import PageTitle from '@/components/PageTitle';
import { useHistory } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

function TermsOfService() {
  const t = useLocale(locale);
  const { theme } = useContext(GlobalContext) || { theme: 'light' };
  const history = useHistory();

  useEffect(() => {
    document.body.setAttribute('arco-theme', theme || 'light');
  }, [theme]);

  return (
    <div className={styles.standalone}>
      <PageTitle titleKey="menu.termsOfService" />
      <div className={styles.header}>
        <a
          href="https://www.suwendata.com/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.logoContainer}
          style={{ cursor: 'pointer', textDecoration: 'none' }}
        >
          <Logo />
          {/* <span className={styles.logoText}>速问</span> */}
        </a>
      </div>

      <div className={styles.container}>
        <Card className={styles.card}>
          <Title heading={2} className={styles.mainTitle}>
            {t['terms.title']}
          </Title>
          <Paragraph className={`${styles.date} ${styles.centered}`}>
            {t['terms.effectiveDate']}
          </Paragraph>

          <Paragraph className={styles.intro}>{t['terms.intro']}</Paragraph>

          <div className={styles.section}>
            <Title heading={4}>{t['terms.section1.title']}</Title>
            <Paragraph>{t['terms.section1.content1']}</Paragraph>
            <Paragraph className={styles.subsection}>
              <Title heading={5}>{t['terms.section1.subtitle1']}</Title>
              <Paragraph>{t['terms.section1.subcontent1']}</Paragraph>
              <ul className={styles.list}>
                <li>{t['terms.section1.list1.item1']}</li>
                <li>{t['terms.section1.list1.item2']}</li>
                <li>{t['terms.section1.list1.item3']}</li>
                <li>{t['terms.section1.list1.item4']}</li>
                <li>{t['terms.section1.list1.item5']}</li>
              </ul>
            </Paragraph>
            <Paragraph className={styles.subsection}>
              <Title heading={5}>{t['terms.section1.subtitle2']}</Title>
              <Paragraph>{t['terms.section1.subcontent2']}</Paragraph>
            </Paragraph>
          </div>

          <div className={styles.section}>
            <Title heading={4}>{t['terms.section2.title']}</Title>
            <Paragraph>{t['terms.section2.content1']}</Paragraph>
            <Paragraph>{t['terms.section2.content2']}</Paragraph>
          </div>

          <div className={styles.section}>
            <Title heading={4}>{t['terms.section3.title']}</Title>
            <Paragraph>{t['terms.section3.content']}</Paragraph>
          </div>

          <div className={styles.section}>
            <Title heading={4}>{t['terms.section4.title']}</Title>
            <Paragraph>{t['terms.section4.content1']}</Paragraph>
            <Paragraph className={styles.subsection}>
              <ul className={styles.list}>
                <li>{t['terms.section4.list.item1']}</li>
                <li>{t['terms.section4.list.item2']}</li>
                <li>{t['terms.section4.list.item3']}</li>
                <li>{t['terms.section4.list.item4']}</li>
              </ul>
            </Paragraph>
          </div>

          <div className={styles.section}>
            <Title heading={4}>{t['terms.section5.title']}</Title>
            <Paragraph>{t['terms.section5.content1']}</Paragraph>
            <Paragraph>{t['terms.section5.content2']}</Paragraph>
          </div>

          <div className={styles.section}>
            <Title heading={4}>{t['terms.section6.title']}</Title>
            <Paragraph>{t['terms.section6.content1']}</Paragraph>
            <Paragraph>{t['terms.section6.content2']}</Paragraph>
          </div>

          <div className={styles.section}>
            <Title heading={4}>{t['terms.section7.title']}</Title>
            <Paragraph>{t['terms.section7.content1']}</Paragraph>
            <Paragraph>{t['terms.section7.content2']}</Paragraph>
          </div>

          <div className={styles.footer}>
            <Text bold>{t['terms.footer.company']}</Text>
            <br />
            <Text>{t['terms.footer.date']}</Text>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default TermsOfService;
